import { render } from "./SolarProduction.vue?vue&type=template&id=1835d7ad&scoped=true"
import script from "./SolarProduction.vue?vue&type=script&lang=js"
export * from "./SolarProduction.vue?vue&type=script&lang=js"

import "./SolarProduction.vue?vue&type=style&index=0&id=1835d7ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1835d7ad"]])

export default __exports__